import * as ambassadorWixAppSettingsV1Settings from './app-settings-v1-settings-app-settings.http.js';
import * as ambassadorWixAppSettingsV1SettingsTypes from './app-settings-v1-settings-app-settings.types.js';
import * as ambassadorWixAppSettingsV1SettingsUniversalTypes from './app-settings-v1-settings-app-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function setComponentSettings(): __PublicMethodMetaInfo<
  'PATCH',
  { componentId: string },
  ambassadorWixAppSettingsV1SettingsUniversalTypes.SetComponentSettingsRequest,
  ambassadorWixAppSettingsV1SettingsTypes.SetComponentSettingsRequest,
  ambassadorWixAppSettingsV1SettingsUniversalTypes.SetComponentSettingsResponse,
  ambassadorWixAppSettingsV1SettingsTypes.SetComponentSettingsResponse
> {
  const payload = { componentId: ':componentId' } as any;

  const getRequestOptions =
    ambassadorWixAppSettingsV1Settings.setComponentSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/api/v1/settings/components/{componentId}',
    pathParams: { componentId: 'componentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getComponentSettings(): __PublicMethodMetaInfo<
  'GET',
  { componentId: string },
  ambassadorWixAppSettingsV1SettingsUniversalTypes.GetComponentSettingsRequest,
  ambassadorWixAppSettingsV1SettingsTypes.GetComponentSettingsRequest,
  ambassadorWixAppSettingsV1SettingsUniversalTypes.GetComponentSettingsResponse,
  ambassadorWixAppSettingsV1SettingsTypes.GetComponentSettingsResponse
> {
  const payload = { componentId: ':componentId' } as any;

  const getRequestOptions =
    ambassadorWixAppSettingsV1Settings.getComponentSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/api/v1/settings/components/{componentId}',
    pathParams: { componentId: 'componentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setGlobalSettings(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixAppSettingsV1SettingsUniversalTypes.SetGlobalSettingsRequest,
  ambassadorWixAppSettingsV1SettingsTypes.SetGlobalSettingsRequest,
  ambassadorWixAppSettingsV1SettingsUniversalTypes.SetGlobalSettingsResponse,
  ambassadorWixAppSettingsV1SettingsTypes.SetGlobalSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAppSettingsV1Settings.setGlobalSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/api/v1/settings/instances',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getGlobalSettings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixAppSettingsV1SettingsUniversalTypes.GetGlobalSettingsRequest,
  ambassadorWixAppSettingsV1SettingsTypes.GetGlobalSettingsRequest,
  ambassadorWixAppSettingsV1SettingsUniversalTypes.GetGlobalSettingsResponse,
  ambassadorWixAppSettingsV1SettingsTypes.GetGlobalSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAppSettingsV1Settings.getGlobalSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/api/v1/settings/instances',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  AppSettings as AppSettingsOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  Host as HostOriginal,
  HostWithLiterals as HostWithLiteralsOriginal,
  SetComponentSettingsRequest as SetComponentSettingsRequestOriginal,
  TranslatedLanguage as TranslatedLanguageOriginal,
  LanguageKey as LanguageKeyOriginal,
  SetComponentSettingsResponse as SetComponentSettingsResponseOriginal,
  SetComponentSettingsForMigrationRequest as SetComponentSettingsForMigrationRequestOriginal,
  SetComponentSettingsForMigrationResponse as SetComponentSettingsForMigrationResponseOriginal,
  GetComponentSettingsRequest as GetComponentSettingsRequestOriginal,
  GetComponentSettingsResponse as GetComponentSettingsResponseOriginal,
  BulkGetComponentSettingsRequest as BulkGetComponentSettingsRequestOriginal,
  BulkGetComponentSettingsResponse as BulkGetComponentSettingsResponseOriginal,
  ComponentSettings as ComponentSettingsOriginal,
  SetGlobalSettingsRequest as SetGlobalSettingsRequestOriginal,
  SetComponentSettingsItem as SetComponentSettingsItemOriginal,
  SetGlobalSettingsResponse as SetGlobalSettingsResponseOriginal,
  GetGlobalSettingsRequest as GetGlobalSettingsRequestOriginal,
  GetGlobalSettingsResponse as GetGlobalSettingsResponseOriginal,
  GetComponentSettingsItem as GetComponentSettingsItemOriginal,
  SetGlobalSettingsForMigrationRequest as SetGlobalSettingsForMigrationRequestOriginal,
  SetGlobalSettingsForMigrationResponse as SetGlobalSettingsForMigrationResponseOriginal,
  GetGlobalSettingsForMigrationRequest as GetGlobalSettingsForMigrationRequestOriginal,
  GetGlobalSettingsForMigrationResponse as GetGlobalSettingsForMigrationResponseOriginal,
  GetRequest as GetRequestOriginal,
  GetResponse as GetResponseOriginal,
  SetRequest as SetRequestOriginal,
  Scope as ScopeOriginal,
  ScopeWithLiterals as ScopeWithLiteralsOriginal,
  SetResponse as SetResponseOriginal,
  UpdateRequest as UpdateRequestOriginal,
  UpdateResponse as UpdateResponseOriginal,
} from './app-settings-v1-settings-app-settings.types.js';
